"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _text = require("../text");

var _core = require("@emotion/core");

var FlyoutTitleText = _text.Text.withComponent('h2', {
  target: "e1uvemeu0"
});

FlyoutTitleText.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps, {
  fontSize: 'T400',
  fontWeight: 'regular',
  color: 'neutral0',
  margin: 0
});
FlyoutTitleText.displayName = 'FlyoutTitleText';

var defaultTitleRenderer = function defaultTitleRenderer(_ref) {
  var titleText = _ref.titleText;
  return (0, _core.jsx)(FlyoutTitleText, null, titleText);
};

exports.defaultTitleRenderer = defaultTitleRenderer;